<template>
  <div class="grid-content">
    <div
      class="loading"
      v-loading="loading"
    >
      <el-form
        ref="globalPriceSetting"
        :model="globalPriceSetting"
        :rules="rules"
        label-width="80px"
      >
        <el-row>
          <el-col :span="3">
            <span>大学补习价格：</span>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="每小时"
              prop="Value"
            >
              <el-input
                :disabled="optionModel.isReadonly"
                placeholder="请输入价格"
                v-model="globalPriceSetting.Value"
                class="input-width"
              >
                <template slot="append">$</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <hr>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row
      v-if="!optionModel.isReadonly"
      class="cs-filter-row"
    >
      <el-col
        :span="4"
        class="footer-left"
      >
        <el-button
          size="medium"
          :disabled="submitBtnDisable"
          :type="submitBtnClass"
          @click="saveChanges"
        >保存更新</el-button>
      </el-col>
      <el-col
        :span="16"
        class="footer-right"
      >
        <el-alert
          :closable="false"
          v-show="showError"
          v-bind:title="errorMessage"
          type="error"
          show-icon
        ></el-alert>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;
    overflow: visible;
    white-space: nowrap;
  }

  .el-input {
    text-align-last: center;
  }
}
</style>

<script>
import {
  getGlobalPriceSettingByType,
  saveGlobalPriceSetting
} from "../../service/globalPriceSetting.service";

export default {
  props: {
    isActive: Boolean,
    options: {
      isReadonly: Boolean
    }
  },
  data() {
    let validateValue = (rule, value, callback) => {
      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入正确的价格";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      isLoadedData: false,
      loading: false,
      optionModel: {
        isReadonly: false
      },
      globalPriceSetting: {},
      submitBtnClass: "info",
      submitBtnDisable: true,
      showError: false,
      errorMessage: "",
      rules: {
        Value: [
          {
            required: true,
            message: "价格不能为空",
            trigger: "blur"
          },
          {
            validator: validateValue,
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {},
  computed: {},
  created() {
    this.loadOptionModelFromProps();
    this.loadGlobalPriceSetting();
  },
  updated() {
    this.checkAllInputs();
  },
  methods: {
    loadOptionModelFromProps(options = this.options) {
      if (!!options) {
        this.optionModel.isReadonly = options.isReadonly;
      } else {
        this.optionModel.isReadonly = false;
      }
    },
    checkAllInputs() {
      let isValid = true;

      let $refGPS = this.$refs["globalPriceSetting"];
      if (!!$refGPS) {
        $refGPS.validate(valid => {
          if (!valid) {
            isValid = false;
            return;
          }
        });
      }

      if (isValid) {
        this.submitBtnClass = "primary";
        this.submitBtnDisable = false;
      } else {
        this.submitBtnClass = "info";
        this.submitBtnDisable = true;
      }

      return isValid;
    },
    loadGlobalPriceSetting() {
      if (!this.isActive){
        return;
      }

      let self = this;

      this.loading = true;
      getGlobalPriceSettingByType(1).then(result => {
        if (!!result && result.success) {
          self.globalPriceSetting = result.data;
          self.loading = false;
          self.isLoadedData = true;
        }
      });
    },
    saveChanges() {
      let self = this;

      let isValid = this.checkAllInputs();
      if (!isValid) {
        return;
      }

      let cacheSubmitBtnDisable = this.submitBtnDisable;
      this.submitBtnDisable = true;
      saveGlobalPriceSetting(this.globalPriceSetting).then(result => {
        if (!result) {
          return;
        }

        if (result.success) {
          self.globalPriceSetting.Id = result.data;
          self.errorMessage = "";
        } else {
          self.errorMessage = result.message;
        }
        self.showError = !result.success;
        this.$message(`保存更新${!self.showError ? "成功" : "失败"}`);
        self.submitBtnDisable = cacheSubmitBtnDisable;
      });
    }
  },
  watch: {
    isActive: function () {
      if (this.isActive && !this.isLoadedData) {
          this.loadGlobalPriceSetting();
      }
    },
    options: function(newVal) {
      this.loadOptionModelFromProps(newVal);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/courseUnitPrice.vue